'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

var _icon = require('../setting/icon.base64');

var _style = require('./style');

var _dofIconfont = require('../dof-iconfont');

var _dofIconfont2 = _interopRequireDefault(_dofIconfont);

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var Navigator = weex.requireModule('navigator');
var platform = weex.config.env.platform.toLowerCase();
exports.default = {
  components: { DofIconfont: _dofIconfont2.default },
  mixins: [_colmo2.default, _diablo2.default],
  props: {
    isFixed: {
      type: Boolean,
      default: false
    },
    isImmersion: {
      type: Boolean,
      default: true
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    hasBottomBorder: {
      type: Boolean,
      default: false
    },
    leftButton: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: ''
    },
    rightButton: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '标题'
    },
    subTitle: {
      type: String,
      default: ''
    },
    leftText: {
      type: String,
      default: ''
    },
    rightText: {
      type: String,
      default: ''
    },
    useDefaultReturn: {
      type: Boolean,
      default: true
    },
    show: {
      type: Boolean,
      default: true
    },
    barStyle: {
      type: Object
    },
    middleTextStyle: {
      type: Object
    }
  },
  created: function created() {
    this.isIPhoneX = _utils2.default.env.isIPhoneX();
  },

  computed: {
    themeStyle: function themeStyle() {
      var _theme = this._theme || (this._isDiablo ? 'diablo' : 'default');
      return _style.STYLE_MAP[_theme] || _style.STYLE_MAP['default'];
    },
    backgroundColor_: function backgroundColor_() {
      return this.backgroundColor ? this.backgroundColor : this.themeStyle.backgroundColor;
    },
    leftButton_: function leftButton_() {
      return this.leftButton ? this.leftButton : !this._isColmo ? this._isDiablo ? _icon.back_diablo : _icon.back_black : '';
    },
    rightButton_: function rightButton_() {
      if (this.rightButton === 'default') {
        return this._isColmo ? 'default' : _icon.icon_more;
      }
      return this.rightButton ? this.rightButton : '';
    },
    leftButtonBlindHelp: function leftButtonBlindHelp() {
      return (this.leftText || '返回') + '\u3002\u6309\u94AE\u3002';
    },

    statusBarHeight: function statusBarHeight() {
      var result = '20';
      if (weex.config.env.statusBarHeight) {
        if (weex.config.env.platform === 'iOS' || weex.config.env.platform == 'harmony') {
          // iOS使用pt为单位
          result = weex.config.env.statusBarHeight;
        } else {
          // 安卓使用px为单位
          result = weex.config.env.statusBarHeight / weex.config.env.scale;
        }
      }
      return result;
    },
    newBarStyle: function newBarStyle() {
      var result = void 0;
      var barStyle = this.barStyle,
          backgroundColor_ = this.backgroundColor_;

      var backgroundColor = backgroundColor_;
      var isIPhoneSE = weex.config.env.deviceModel.substr(6) === '12,8';
      // harmony
      if (_utils2.default.env.isHarmony()) return _extends({
        backgroundColor: backgroundColor,
        height: +this.statusBarHeight + 44 + 'wx',
        'padding-top': this.statusBarHeight + 'wx'
      }, barStyle);

      if (this.isImmersion) {
        // 全屏显示，weex自行处理状态栏高度
        result = _extends({
          backgroundColor: backgroundColor,
          paddingTop: (isIPhoneSE ? 20 : this.statusBarHeight) + 'wx'
        }, barStyle);
      } else {
        // 非全屏显示，app已处理状态栏高度
        result = _extends({
          backgroundColor: backgroundColor,
          height: '44wx'
        }, barStyle);
      }
      return result;
    },
    newTextWrapStyle: function newTextWrapStyle() {
      if (this.textColor) {
        return _extends({
          color: this.textColor
        }, this.middleTextStyle);
      } else {
        return _extends({
          color: this.themeStyle.middleTitleColor
        }, this.middleTextStyle);
      }
    },
    newTextWrapStyleSubTitle: function newTextWrapStyleSubTitle() {
      if (this.textColor) {
        return {
          color: this.textColor
        };
      } else {
        return _extends({
          color: this.themeStyle.middleSubTitleColor
        }, this.middleTextStyle);
      }
    },
    newTextStyle: function newTextStyle() {
      if (this.textColor) {
        return {
          color: this.textColor,
          marginLeft: '0px'
        };
      }
      return {};
    }
  },
  methods: {
    leftButtonClicked: function leftButtonClicked() {
      if (this.useDefaultReturn) {
        Navigator.pop({}, function (e) {});
      }
      this.$emit('dofMinibarLeftButtonClicked', {});
    },
    rightButtonClicked: function rightButtonClicked() {
      var hasRightContent = this.rightText || this.rightButton || this.$slots && this.$slots.right;
      hasRightContent && this.$emit('dofMinibarRightButtonClicked', {});
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-minibar/index.vue
// module id = 348
// module chunks = 0 1